import { easeOut } from "ol/easing";
import { getLocalizedText } from "../common/translations";
import ControlBase, { IControlBaseOptions } from "./controlBase";

export default class CustomZoomControl extends ControlBase {
    
    constructor(options: IControlBaseOptions) {
        let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Bootstrap ikona Plus https://icons.getbootstrap.com/icons/plus/
        svg.innerHTML = `<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>`;
        svg.setAttribute("width", "24px");
        svg.setAttribute("height", "24px");
        svg.setAttribute("viewBox", "0 0 16 16");
        options.symbol = svg;
        options.tooltipText = getLocalizedText("controlZoomIn");
        super(options);

        let button = document.createElement("button");
        button.type = "button";
        svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        // Bootstrap ikona Dash https://icons.getbootstrap.com/icons/dash/
        svg.innerHTML = `<path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>`;
        svg.setAttribute("width", "24px");
        svg.setAttribute("height", "24px");
        svg.setAttribute("viewBox", "0 0 16 16");
        svg.classList.add("symbol");
        button.appendChild(svg);
        this.container.appendChild(button);
        let res = this.createTooltip(getLocalizedText("controlZoomOut"), options.tooltipContainer ?? this.container, button);

        this.container.classList.add("ol-zoom");
        this.button.classList.add("ol-zoom-in");
        button.classList.add("ol-zoom-out");

        this.button.addEventListener("click", this.zoomIn.bind(this));
        button.addEventListener("click", this.zoomOut.bind(this));
    }

    private zoomIn() {
        this.changeZoom(1);
    }

    private zoomOut() {
        this.changeZoom(-1);
    }

    private changeZoom(factor: number) {
        const map = this.getMap();
        const view = map.getView();
        if (!map || !view) {
            return;
        }
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + factor);
            if (view.getAnimating()) {
                view.cancelAnimations();
            }
            view.animate({
                zoom: newZoom,
                duration: 250,
                easing: easeOut,
            });
        }
    }
}